import { StyleSheet, css } from 'aphrodite'
import type React from 'react'
import { type TagStatus, formatTagStatus } from '../types/tag'

interface StatusBadgeProps {
  status: TagStatus
}

const getStatusStyle = (status: TagStatus) => {
  const upperStatus = status.toUpperCase()
  switch (upperStatus) {
    case 'IN_PROGRESS':
      return StatusBadgeStyles.inProgress
    case 'ACCEPTED':
      return StatusBadgeStyles.accepted
    case 'NEW':
      return StatusBadgeStyles.new
    case 'SIGNED':
      return StatusBadgeStyles.signed
    case 'COMPLETE':
      return StatusBadgeStyles.complete
    case 'DECLINED':
      return StatusBadgeStyles.declined
    default:
      return StatusBadgeStyles.new
  }
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  return (
    <span className={css(StatusBadgeStyles.statusCard, getStatusStyle(status))}>
      <span className={css(StatusBadgeStyles.statusText)}>
        {formatTagStatus(status)}
      </span>
    </span>
  )
}

const StatusBadgeStyles = StyleSheet.create({
  statusCard: {
    position: 'relative',
    height: '24px',
    width: '100px',
    background: '#FDE68A',
    color: '#4B5563',
    borderRadius: 6,
    fontWeight: 600,
    fontSize: '12px',
    textAlign: 'center',
    overflow: 'hidden',
    display: 'inline-block',
  },
  statusText: {
    position: 'absolute',
    top: '50%',
    left: 0,
    right: 0,
    transform: 'translateY(-50%)',
    textAlign: 'center',
    lineHeight: 1,
  },
  accepted: {
    color: '#FFFFFF',
    background: '#10B981',
    fontWeight: 600,
  },
  inProgress: {
    color: '#059669',
    background: '#DEF7EC',
    fontWeight: 600,
  },
  new: {
    color: '#1E429F',
    background: '#E1EFFE',
    fontWeight: 600,
  },
  signed: {
    color: '#FFFFFF',
    background: '#F97316',
    fontWeight: 600,
  },
  complete: {
    color: '#FFFFFF',
    background: '#7C3AED',
    fontWeight: 600,
  },
  declined: {
    color: '#EF4444',
    background: '#FEE2E2',
    fontWeight: 600,
  },
})

export default StatusBadge
